import {Vue} from "ui.vue";

import "citrus.vue.product.basket-button";

import ProductItem from "./components/base.vue";

Vue.component("CitrusProductItem", ProductItem);
